import request from '@/utils/request'

//7.1招聘列表接口
export function gangweiList(lang, data) {
    return request({
        url: `/${lang}/wms/dqgx/gangweiList`,
        method: 'post',
        data
    })
}

//8.1留言、联系我们、简历投递提交
export function submitReporter(lang, data) {
    return request({
        url: `/${lang}/wms/dqgx/submitReporter`,
        method: 'post',
        data
    })
}

// 8.2文件上传接口
export function uploadFile(lang, file) {
    let formData = new FormData()
    formData.append('filedName', file)
    return request({
        url: `/${lang}/wms/dqgx/uploadFile`,
        method: 'post',
        header: {
            'Content-Type': 'multipart/form-data'
        },
        data: formData
    })
}